const RelatoriosDisponibilidade = () =>
  import(/* webpackChunkName: "group-callcenter-relatorios-disponibilidade" */ '../_views/RelatoriosDisponibilidade')

import { permissionsRelatorioDisponibilidade } from '../../../../../utils/permissionsCallCenter'

export default [
  {
    path: 'disponibilidade',
    meta: { requiresAuth: true, permissions: [...permissionsRelatorioDisponibilidade] },
    component: RelatoriosDisponibilidade,
    name: 'RelatorioDisponibilidade',
  },
]
